<template>
  <nav
    v-if="$route.meta.header === 1"
    position="fixed"
    class="navbar fixed-top active"
  >
    <div class="container-fluid">
      <!--img style="width: auto; height: auto;" src="static/img/doodhvale_logo.png" alt="abc">
      <a class="navbar-brand" href="#">Dashboard</a-->
      <router-link
        :to="{ path: '/a/reg' }"
        v-popover:popover1
        class="navbar-brand"
      >
        <img alt="doodhvale logo" src="/static/img/d-logo.png" />
      </router-link>
      <button
        mat-raised-button=""
        v-on:click.prevent="goToEvents()"
        class="mat-raised-button btn btn-info btn-md dv-primary-btn mobile-view"
      >
        <span class="mat-button-wrapper">INSTALL APP</span>
        <div class="mat-button-ripple mat-ripple" matripple=""></div>
        <div class="mat-button-focus-overlay"></div>
      </button>
      <!-- <button type="button" class="navbar-toggler navbar-toggler-right" :class="{ toggled: $sidebar.showSidebar }"
        aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a>
          </li>
          <drop-down tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="#">
              Account
            </a>
          </li>
          <drop-down title="Dropdown">
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <div class="divider"></div>
            <a class="dropdown-item" href="#">Separated link</a>
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link">
              Log out
            </a>
          </li>
        </ul>
      </div> -->
    </div>
  </nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    goToEvents() {
      location.href = "https://v.doodhvale.in/#/a/appLink";
    },
  },
};
</script>
<style>
@media (max-width: 991px) {
  .navbar {
    padding-right: 10px;
    padding-left: 10px;
  }
}
.fixed-top {
  position: sticky;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.navbar-brand .active {
  background-color: #fff !important;
}

.navbar {
  padding-top: 0.025rem;
  padding-bottom: 0.025rem;
  min-height: 40px;
  -webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  /* box-shadow: 0 0 20px 0 rgba(0,0,0,.15); */
}
.bg-white {
  background-color: #fff !important;
}
.dv-primary-btn {
  background-color: #74c7fc !important;
  font-family: Poppins Medium !important;
  letter-spacing: 2px;
  padding: 11px 23px !important;
}
.btn-info,
.el-date-picker.date-picker-primary
  .el-picker-panel__footer
  .el-button:first-child {
  background-color: #2ca8ff;
  color: #fff;
}
.btn,
.navbar .navbar-nav > a.btn {
  border-width: 2px;
  font-weight: 400;
  font-size: 0.8571em;
  line-height: 1.35em;
  margin: 10px 1px;
  border: none;
  border-radius: 0.1875rem;
  padding: 11px 22px;
  cursor: pointer;
  background-color: #313232;
  color: #fff;
}
button,
select {
  text-transform: none;
}
.btn-info:hover,
.el-date-picker.date-picker-primary
  .el-picker-panel__footer
  .el-button:hover:first-child {
  -webkit-box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}

.btn-info:hover {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue